"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.suspenseQueryTypes = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _jsTools = require("@airportlabs/js-tools");
var _client = require("@apollo/client");
var _get3 = _interopRequireDefault(require("lodash/get"));
var _identity = _interopRequireDefault(require("lodash/identity"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _react = require("react");
var _useOperationSubscription = _interopRequireDefault(require("./useOperationSubscription"));
var _excluded = ["unpackDataMemo", "skip", "name", "queryType", "debug"]; // Requires apollo-client >3.9.0
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var suspenseQueryTypes = exports.suspenseQueryTypes = {
  // useSuspenseQuery
  SUSPENSE: "suspense",
  // useBackgroundQuery
  BACKGROUND: "background",
  // useLoadableQuery
  LOADABLE: "loadable"
};

/**
 * Utility function that returns the path for a first field found at a specific
 * depth in a GraphQL operation.
 *
 * Example: Passing the following "graphql" operation:
 *   gql`query exampleQuery($in: ExampleQueryInput!) {
 *     getExampleQuery(in: $in) {
 *       items {
 *         id
 *         name
 *       }
 *     }
 *   }`
 * with a depth of "2" would return "getExampleQuery.items".
 *
 * @param {DocumentNode} graphql The graphql operation AST as returned by
 * wrapping the operation string with `gql`. That would be the EXAMPLE_QUERY
 * that would be passed to "useQuery".
 * @param {number} depth? - The depth of the field in the selection set for
 * which we need the path.
 *
 * @returns {string | undefined} The path in the selection set to the first
 * field found at the given depth
 */
var getDepthPath = function getDepthPath(_ref) {
  var graphql = _ref.graphql,
    depth = _ref.depth;
  var operationDefinition = graphql.definitions.find(function (def) {
    return def.kind === "OperationDefinition";
  });
  var extractNodeName = function extractNodeName(node) {
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    if (!node || !node.selectionSet) {
      return;
    }
    var firstChild = node.selectionSet.selections.find(function (selection) {
      return selection.kind === "Field";
    });
    if (depth <= 1) {
      return firstChild.name.value;
    }
    var deeperPath = extractNodeName(firstChild, depth - 1);
    if (!deeperPath) {
      return;
    }
    return "".concat(firstChild.name.value, ".").concat(deeperPath);
  };
  return extractNodeName(operationDefinition, depth);
};

/**
 * Keeping a TS version of the above function for when we migrate to TS.
 */

// import {
//   DocumentNode,
//   ExecutableDefinitionNode,
//   FieldNode,
//   Kind,
//   OperationDefinitionNode,
//   parse,
// } from "graphql";

// const getDepthPath = ({
//   graphql,
//   depth,
// }: {
//   graphql: DocumentNode;
//   depth?: number;
// }): string | undefined => {
//   const operationDefinition = graphql.definitions.find(
//     (def) => def.kind === "OperationDefinition"
//   ) as OperationDefinitionNode | undefined;

//   const extractNodeName = (
//     node: FieldNode | OperationDefinitionNode | undefined,
//     depth = 1
//   ): string | undefined => {
//     if (!node || !node.selectionSet) {
//       return;
//     }

//     const firstChild = node.selectionSet.selections.find(
//       (selection) => selection.kind === "Field"
//     ) as FieldNode;

//     if (depth <= 1) {
//       return firstChild.name.value;
//     }

//     const deeperPath = extractNodeName(firstChild, depth - 1);
//     if (!deeperPath) {
//       return;
//     }

//     return `${firstChild.name.value}.${deeperPath}`;
//   };

//   return extractNodeName(operationDefinition, depth);
// };

var useSuspenseSubscription = function useSuspenseSubscription(_ref2) {
  var GRAPHQL_QUERY = _ref2.query,
    GRAPHQL_SUBSCRIPTION = _ref2.subscription,
    options = _ref2.options;
  var _ref3 = options || {},
    _ref3$unpackDataMemo = _ref3.unpackDataMemo,
    unpackData = _ref3$unpackDataMemo === void 0 ? _identity["default"] : _ref3$unpackDataMemo,
    skip = _ref3.skip,
    name = _ref3.name,
    _ref3$queryType = _ref3.queryType,
    queryType = _ref3$queryType === void 0 ? suspenseQueryTypes.SUSPENSE : _ref3$queryType,
    _ref3$debug = _ref3.debug,
    debug = _ref3$debug === void 0 ? false : _ref3$debug,
    operationHookOptions = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  if (!Object.values(suspenseQueryTypes).includes(queryType)) {
    throw new Error('useSuspenseSubscription: Invalid "queryType" provided. Please use the "suspenseQueryTypes" enum to specify the query type.');
  }
  var client = (0, _client.useApolloClient)();
  var queryResponse = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, suspenseQueryTypes.SUSPENSE, _client.useSuspenseQuery), suspenseQueryTypes.BACKGROUND, _client.useBackgroundQuery), suspenseQueryTypes.LOADABLE, _client.useLoadableQuery)[queryType](GRAPHQL_QUERY,
  // https://www.apollographql.com/docs/react/data/suspense#skipping-suspense-hooks
  !skip ? operationHookOptions : _client.skipToken);
  var graphqlConsole = (0, _jsTools.getGraphqlConsole)(debug);
  var depthPath = getDepthPath({
    graphql: GRAPHQL_QUERY,
    depth: 2
  });
  var skipSubscription = skip || queryType === suspenseQueryTypes.LOADABLE && !queryResponse[1];
  var variablesJSON = (operationHookOptions === null || operationHookOptions === void 0 ? void 0 : operationHookOptions.variables) && JSON.stringify(operationHookOptions.variables);
  var subscriptionResponse = (0, _useOperationSubscription["default"])(GRAPHQL_SUBSCRIPTION, _objectSpread({
    skip: skipSubscription
  }, operationHookOptions), {
    onFlush: (0, _react.useCallback)(function (data) {
      var _get;
      if (!depthPath) {
        console.error("Cannot update ".concat(getDepthPath({
          graphql: GRAPHQL_QUERY,
          depth: 0
        }), " query cache with data from subscription because cannot find path of depth 2 in the query."));
        return;
      }
      var variables = variablesJSON && JSON.parse(variablesJSON);
      var oldCache = client.readQuery({
        query: GRAPHQL_QUERY,
        variables: variables
      });
      var queryName = depthPath.split(".")[0];
      var newCache = (0, _set2["default"])((0, _defineProperty2["default"])({}, queryName, {
        __typename: (_get = (0, _get3["default"])(oldCache, queryName)) === null || _get === void 0 ? void 0 : _get.__typename
      }), depthPath, data);
      if (!(0, _isEqual["default"])((0, _jsTools.removeTypename)(oldCache), (0, _jsTools.removeTypename)(newCache))) {
        client.writeQuery({
          query: GRAPHQL_QUERY,
          data: newCache,
          variables: variables
        });
        graphqlConsole.log("".concat(queryName, ": Updated cache with subscription data:"), newCache);
      } else {
        graphqlConsole.log("".concat(queryName, ": Skipped updating cache as the subscription data is the same as the current query cache:"), newCache);
      }
    }, [GRAPHQL_QUERY, client, depthPath, graphqlConsole, variablesJSON]),
    name: name,
    debug: debug
  });
  var data = (0, _react.useMemo)(function () {
    var _get2;
    return queryType === suspenseQueryTypes.BACKGROUND ? undefined : (_get2 = (0, _get3["default"])(queryResponse.data, depthPath)) === null || _get2 === void 0 ? void 0 : _get2.map(unpackData);
  }, [depthPath, queryResponse.data, queryType, unpackData]);
  return {
    data: data,
    queryResponse: queryResponse,
    subscriptionResponse: subscriptionResponse,
    isFlushingQueue: subscriptionResponse.isFlushingQueue,
    updateCache: subscriptionResponse.updateCache
  };
};
var _default = exports["default"] = useSuspenseSubscription;